import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdminService } from '../../../../modules/administration/services/admin.service';

@Component({
  selector: 'app-in-active-assessments-dialog',
  templateUrl: './in-active-assessments-dialog.component.html',
  styleUrls: ['./in-active-assessments-dialog.component.scss'],
  standalone: false,
})
export class InActiveAssessmentsDialogComponent {
  @Input() assessmentListSelection: string[];
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  loadSpinner: boolean;

  constructor(private adminService: AdminService) { }

  inactive(): void {
    this.loadSpinner = true;
    this.adminService
      .inactiveAssessments(this.assessmentListSelection)
      .subscribe(() => {
        this.loadSpinner = false;
        this.closeDialog.emit(false);
      });
  }
  onCloseDialog(): void {
    this.closeDialog.emit(false);
  }
}
